export enum SectionType {
    MAIN = 'main',
    SUB = 'sub'
}
